export type Bonus = {
  number: string
  title: string
  body: string
  cover: string
}

/**
 * Los 5 bonus reales del pack (ficha DPS-30 · Baseball Practice Ready).
 * Las portadas son imágenes de muestra — reemplazar cada `cover` por la
 * portada real del bonus antes de lanzar.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Pick-My-Practice: The 1-Page Decision Flowchart',
    body: 'Answer three questions — how many kids, how much time, what to focus on — and the flowchart sends you to the exact practice to run today. One printable page, plus a short how-to.',
    cover:
      'https://cdn.magicpatterns.com/uploads/xcHYW3AjqX4aZEDTr5XJki/bono1.webp',
  },
  {
    number: '02',
    title: 'The Age & Level Cheat Sheet',
    body: 'For 5-6, 7-8, 9-10, 11-12 and 13+: what to emphasize, which level to run by default (Rookie / Ready / Rising), what to skip, and realistic expectations — so the pack fits the team in front of you.',
    cover:
      'https://cdn.magicpatterns.com/uploads/4qNNz3fxeK3VUT5gZijDUC/bono2.webp',
  },
  {
    number: '03',
    title: 'Start Here: The 10-Minute Quick-Start Guide',
    body: 'In ten minutes you go from “just bought it” to “ready for today”: how the pack is organized, how to pick your first practice, and exactly what to print.',
    cover:
      'https://cdn.magicpatterns.com/uploads/6oyyyiSAk3DepwZeNi9xJt/bono3.webp',
  },
  {
    number: '04',
    title: "The Coach's Confidence Scripts: Exactly What to Say",
    body: 'The exact words for the moments that matter: introducing yourself on day one, explaining a drill in ten seconds, picking up a kid who’s struggling, the pre-game huddle and the two-minute post-game talk.',
    cover:
      'https://cdn.magicpatterns.com/uploads/bXvBnvG1YXMWVTGA4X16kG/bono_4.webp',
  },
  {
    number: '05',
    title: 'The Never-Forget Equipment & Budget-Gear Guide',
    body: 'What you absolutely need, cheap substitutions when something’s missing, and a “field setup in 10 minutes” map — so you never show up short a piece of gear again.',
    cover:
      'https://cdn.magicpatterns.com/uploads/fGXcLhDTx6q4n7PM5kaHVD/bono_5.webp',
  },
]
